
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["feather feather-grip-vertical",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","class":"feather feather-grip-vertical"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"9","cy":"5","r":"1"}}),_c('circle',{attrs:{"cx":"9","cy":"12","r":"1"}}),_c('circle',{attrs:{"cx":"9","cy":"19","r":"1"}}),_c('circle',{attrs:{"cx":"15","cy":"5","r":"1"}}),_c('circle',{attrs:{"cx":"15","cy":"12","r":"1"}}),_c('circle',{attrs:{"cx":"15","cy":"19","r":"1"}})])
          )
        }
      }
    